import { BookOpen } from 'lucide-react';

export default function Content() {
  return (
    <div className="space-y-5" data-testid="admin-content-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Content Management</h1>
        <p className="text-slate-500 text-sm mt-0.5">Manage platform content and announcements</p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
        <BookOpen className="w-12 h-12 text-slate-200 mx-auto mb-4" />
        <h3 className="font-heading text-lg font-semibold text-slate-700 mb-2">Content Module</h3>
        <p className="text-slate-400 text-sm max-w-xs mx-auto">Manage product categories, platform announcements, and help documentation.</p>
        <span className="inline-block mt-4 text-xs font-semibold bg-amber-50 text-amber-700 px-3 py-1.5 rounded-full">Coming Soon</span>
      </div>
    </div>
  );
}
